
// 角色权限弹框
import React, { Component } from 'react';
import { message, Modal, Form, Input, Button, Table, Popconfirm, Select } from 'antd';
import '../../../static/css/index.css'
import { getJobUserList } from '../../../apis/api'

const { Option } = Select;

class JobUser extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:'',
        flag:false,
        jobUserList:[],
        currentPage:1,
        currentPageSize:10,
        total:0,
    }
  }

  componentDidMount(){
    
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.visible&&this.props.role_uuid&&this.props.details){
            this.getJobUserList(this.props.role_uuid,this.props.details);
        }

    })

  }

  
  componentWillReceiveProps(nextProps) { 
    if(nextProps.visible&&nextProps.details&&nextProps.details!==this.details&&nextProps.role_uuid){
        this.getJobUserList(nextProps.role_uuid,nextProps.details);
    }

  }

  getJobUserList(role_uuid,details){
    let _this=this;
    this.setState({flag:true})
    const { access_token, currentPage, currentPageSize } = this.state;
    let params={
        access_token:access_token,
        role_uuid:role_uuid?role_uuid:_this.props.role_uuid,
        level:details&&details.level?details.level:_this.props.details.level,
        job_type:details&&details.job_type?details.job_type:_this.props.details.job_type,
        page:currentPage,
        page_size:currentPageSize
    }
 
    getJobUserList(params).then( (data)=> {

        if(data.code === 0){
      
            let jobUserList=data.content.list;
            let total=data.content.paging.total_record;
            _this.setState({ jobUserList, total, flag:false })

        }else{

            message.error(data.message); 
        }
    });

  }  

  //页码变化
  handleTableChange = pagination => {
    var _this = this;
    const current = pagination.current || 1;
    this.setState({ currentPage: current },()=>{
        _this.getJobUserList();
    });
  }
  
//   //搜索
//   searchJobUser = () =>{
//     let _this=this;
//     _this.props.form.validateFields((err, values) => {
//       if(err) {
//           console.log('submit error:' ,err);
//       }else {
//         _this.setState({currentPage:1,search_params:values},()=>{
//             _this.getJobUserList(values);
//         })
//       }
//     });
//   }

  // 点击确定、取消按钮
  handleOk = (e) => {
    this.setState({ 
        currentPage:1,
        currentPageSize:10,
        total:0,
    },()=>{
        this.props.cancelModal();
    });
  }

  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible } = this.props;
    const { currentPage, curPageSize, total, jobUserList, flag } = this.state;

    const columns=[{
      },{
        title: '部门',
        dataIndex: 'org_name',
        width:'20%',
        align:'center',
      },{
        title: '职位',
        dataIndex: 'job_type',
        width:'20%',
        align:'center',
      },{
        title: '姓名',
        dataIndex: 'name',
        width:'20%',
        align:'center',
      },{
        title: 'OA',
        dataIndex: 'username',
        width:'20%',
        align:'center',
       },{
        title: '手机号码',
        dataIndex: 'mobile',
        width:'20%',
        align:'center',
    }];

    return (

       <div className='role_user_form'>
         <Modal
            title="查看员工信息"
            visible={visible}
            onCancel={this.handleOk}
            footer={null}
            width={'80%'}
         >
       
          {/* <div className='search_form'>
            <Form layout="inline">
                <Form.Item label="层级">
                    {getFieldDecorator('level', {
                        initialValue:undefined
                    })(
                        <Select allowClear placeholder='请选择层级' style={{width:200}}>
                            <Option key={1} value={1}>总部</Option>
                            <Option key={2} value={2}>区域</Option>
                            <Option key={3} value={3}>城市</Option>
                            <Option key={4} value={4}>项目</Option>
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="岗位名称">
                    {getFieldDecorator('job_type', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入岗位名称' style={{width:200}} onPressEnter={this.searchJobUser} />
                    )}
                </Form.Item>

                <Form.Item>
                   <Button type='primary' onClick={this.searchJobUser}>搜索</Button>
                </Form.Item>

            </Form>
          </div> */}

          <div className="layout_content_table">
                <Table rowKey='user_uuid' scroll={{ y: 400 }} columns={columns} dataSource={jobUserList} loading={flag} 
                       pagination={{
                            current: currentPage,
                            pageSize: curPageSize,
                            total: total
                       }}
                        onChange={this.handleTableChange}/>
          </div>

         </Modal>

       </div>
    );
  }
}

JobUser = Form.create({
   
})(JobUser);
export default JobUser;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/jobUser.js